import type { Object3D } from 'three';

/**
 * Find an object with userData.id by traversing up the hierarchy
 */
export const findObjectWithId = (object: Object3D): Object3D | null => {
	let current: Object3D | null = object;

	while (current) {
		if (current.userData && current.userData.id) {
			return current;
		}
		current = current.parent;
	}

	return null;
};
